<!-- 绑定管理 -->
<template>
  <div class="phone-container">
    <div class="phone-container-view">
      <div class="input-phone">
        <div class="input-item">
          <div style="padding-right: 100px">已绑定手机:</div>
          <div>177****2161</div>
        </div>
        <div class="input-item" style="margin-top: 40px">
          <div style="padding-right: 90px">短信验证码：</div>
          <el-input
            v-model="input"
            placeholder="请输入手机号"
            style="width: 300px"
          ></el-input>
          <span class="suffix" style="margin-left: -90px; z-index: 999"
            >获取验证码</span
          >
        </div>
        <div class="input-item" style="margin-top: 40px">
          <div style="padding-right: 90px"></div>
          <el-button
            type="primary"
            style="margin-top: 20px"
            @click="changePhomeClick(0)"
            >下一步</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
   
   <script>
export default {
  data() {
    return {
      input: "",
    };
  },
  methods: {
    changePhomeClick(vl) {
      this.changePhomeType = vl;
    },
  },
};
</script>
   
   <style lang="scss" scoped>
.phone-container {
  background-color: white;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 30px;
  .phone-container-view {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 100px;
    .user-phone {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 240px;
        height: 146px;
      }
      color: #1f1f1f;
      font-size: 20px;
      font-weight: 700;
    }
    .input-phone {
      padding: 30px 450px;
      display: flex;
      flex-direction: column;
      align-items: self-start;
      width: 100%;
      .input-item {
        display: flex;
        align-items: center;
      }
    }
  }
  .link {
    padding-left: 10px;
    color: -webkit-link;
    cursor: pointer;
    text-decoration: underline;
    color: #488eff !important;
  }
}
.suffix {
  margin-left: -75px; /* 与输入框间隔 */
  z-index: 99;
  color: #488eff;
}
</style>